import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { getPermissions, PermissionName, User } from '../../model/userdata';
import { PermissionsService } from '../permissions/permissions.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApolloService } from '@src/app/services/apollo/apollo.service';

/**
 * Routeguard that checks if you are allowed to access configurations.
 */
@Injectable()
export class AccessConfigurationsGuardService {
  constructor(
    private _apolloService: ApolloService,
    private _permissionsService: PermissionsService,
    private _router: Router
  ) {
  }

  /**
   * Method that checks if allowed.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this._apolloService.getCurrentUser$().pipe(
      map((u: User) => {
        if (this._permissionsService.isPermitted(
          getPermissions(u.roles), 'access_configurations', PermissionName.Read)
        ) {
          return true;
        }

        this._router.navigateByUrl('/');
        return false;
      }),
      catchError(_ => of(false)));
  }

  /**
   * Method that checks if allowed.
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.canActivate(route, state);
  }
}
